<div class="card shadow-sm mb-4">
    <div class="card-body">
        @if (!canAddClient) {
            <div class="alert alert-info mb-3" role="alert">
                Clients limit is reached. Please upgrade to premium version to add and manage more clients
            </div>
        }
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">Manage Clients ({{ clients().length }})</h5>
            @if (!showAddClientForm) {
                @if (!canAddClient) {
                    <button type="button" class="btn btn-premium btn-sm" (click)="onPremiumAddClientClick()">
                        <i class="bi bi-star-fill"></i> Add Client
                    </button>
                } @else {
                    <button type="button" class="btn btn-outline-success btn-sm" (click)="toggleAddClientForm()">
                        Add Client
                    </button>
                }
            }
        </div>

        @if (showAddClientForm) {
            <form [formGroup]="clientForm" (ngSubmit)="onSubmit()" class="mb-4" novalidate autocomplete="off">
                <div class="row gy-4">
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Client Name*" formControlName="clientName"
                            [ngClass]="{'is-invalid': clientForm.get('clientName')?.invalid && clientForm.get('clientName')?.touched}" />
                    </div>
                    <div class="col-md-6">
                        <input id="clientEmail" type="email" class="form-control" placeholder="Email*" formControlName="clientEmail"
                            [ngClass]="{'is-invalid': clientForm.get('clientEmail')?.invalid && clientForm.get('clientEmail')?.touched}" />
                    </div>
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Phone" formControlName="clientPhone" />
                    </div>
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Website" formControlName="clientWebsite" />
                    </div>
                    <div class="col-md-12">
                        <input type="text" class="form-control" placeholder="Address*" formControlName="clientAddress"
                            [ngClass]="{'is-invalid': clientForm.get('clientAddress')?.invalid && clientForm.get('clientAddress')?.touched}" />
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="City*" formControlName="clientCity"
                            [ngClass]="{'is-invalid': clientForm.get('clientCity')?.invalid && clientForm.get('clientCity')?.touched}" />
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="Province*" formControlName="clientProvince"
                            [ngClass]="{'is-invalid': clientForm.get('clientProvince')?.invalid && clientForm.get('clientProvince')?.touched}" />
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="Postal Code*" formControlName="clientPostalCode"
                            [ngClass]="{'is-invalid': clientForm.get('clientPostalCode')?.invalid && clientForm.get('clientPostalCode')?.touched}" />
                    </div>
                    <div class="col-md-12">
                        <select class="form-select" formControlName="clientCountry"
                            [ngClass]="{'is-invalid': clientForm.get('clientCountry')?.invalid && clientForm.get('clientCountry')?.touched}">
                            <option value="Canada">Canada</option>
                            <option value="USA">USA</option>
                            <option value="India">India</option>
                            <option value="Europe">Europe</option>
                            <option value="UK">UK</option>
                        </select>
                    </div>
                    <div class="col-md-12 d-flex gap-2">
                        <button type="submit" class="btn btn-outline-success btn-sm" [disabled]="clientForm.invalid">
                            {{ editingClientId ? 'Update Client' : 'Save Client' }}
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="toggleAddClientForm()">
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        }

        <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                    <tr>
                        <th>Name</th>
                        <th class="d-none d-sm-table-cell">Email</th>
                        <th class="d-none d-sm-table-cell">City</th>
                        <th>Status</th>
                        <th class="text-end">Action</th>
                    </tr>
                </thead>

                <tbody>
                    @for(item of clients(); track $index; let i = $index;){
                        <tr>
                            <td>{{item.name}}</td>
                            <td class="d-none d-sm-table-cell">{{item.email}}</td>
                            <td class="d-none d-sm-table-cell">{{item.address.city}}</td>
                            <td>
                                <span class="badge bg-success-subtle text-success">
                                    {{item.isActive}}
                                </span>
                            </td>
                            <td class="text-end">
                                <div class="d-flex flex-column flex-md-row gap-2 justify-content-end">
                                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="editClient(item)">Edit</button>
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>